// Uses WeakMap for automatic GC when arrays are no longer referenced
const elementSearchCache = new WeakMap<any[], Map<string, any>>()

export const clearElementSearchCache = () => {
    // WeakMap auto-GC'd, this exists for API compatibility
}
export const findElementRecursively = (
    elements: any[] | undefined,
    targetId: string,
    useCache: boolean = true
): any => {
    if (!elements || !targetId) return null

    if (useCache) {
        const arrayCache = elementSearchCache.get(elements)
        if (arrayCache && arrayCache.has(targetId)) {
            return arrayCache.get(targetId)
        }
    }

    let result: any = null
    for (const element of elements) {
        if (element?.id === targetId) {
            result = element
            break
        }
        if (element?.elements && Array.isArray(element.elements)) {
            const found = findElementRecursively(element.elements, targetId, false)
            if (found) {
                result = found
                break
            }
        }
    }

    if (useCache) {
        let arrayCache = elementSearchCache.get(elements)
        if (!arrayCache) {
            arrayCache = new Map<string, any>()
            elementSearchCache.set(elements, arrayCache)
        }
        arrayCache.set(targetId, result)
    }

    return result
}

export const findParentNode = (
    nodes: any[] | undefined,
    parentId: string
): any => {
    if (!nodes || !parentId) return null

    const topLevelNode = nodes.find((node) => node.id === parentId)
    if (topLevelNode) return topLevelNode

    for (const node of nodes) {
        const found = findElementRecursively(node.elements, parentId)
        if (found) return found
    }

    return null
}

export const extractBPFlagsFromElement = (
    nodes: any[] | undefined,
    parentContentItemId: string,
    elementId: string
): { isBestPractice: boolean; isGlobalBestPractice: boolean } => {
    const defaultFlags = {
        isBestPractice: false,
        isGlobalBestPractice: false,
    }

    if (!nodes || !parentContentItemId || !elementId) {
        return defaultFlags
    }

    const parentNode = findParentNode(nodes, parentContentItemId)
    if (!parentNode) return defaultFlags

    const element = findElementRecursively(parentNode.elements, elementId)
    if (!element) return defaultFlags

    return {
        isBestPractice: element.isBestPractice ?? false,
        isGlobalBestPractice: element.isGlobalBestPractice ?? false,
    }
}
